// CERRAR SESIÓN CON PENDIENTES · DIRECTRIZ-PWA F2 (11 oct 2026, DISENO-F2 §10, D-13).
//
// Lo que se borra al cerrar sesión es la copia de las listas
// (`cacheTrabajo`, `auth.jsx`), NUNCA las colas: lo guardado sin señal
// espera a que esa cuenta vuelva a entrar. La persona tiene que saberlo
// antes de pulsar. `auth.jsx` no se toca (R-PWA-5): la pregunta vive en
// `AppShell`, delante del botón «Cerrar sesión» del menú. El cierre por
// inactividad no pregunta: seguridad por encima; las colas sobreviven igual.

/**
 * Decide si se cierra ya o se pregunta antes.
 *   contar()      → Promise<número de pendientes de enviar de esta cuenta>
 *   cerrar()      → cierra la sesión
 *   preguntar(n)  → abre la confirmación con n
 * Devuelve 'cerrada' o 'pregunta'. Si contar falla, se cierra sin preguntar:
 * nunca se deja a alguien sin poder salir.
 */
export async function decidirSalida({ contar, cerrar, preguntar }) {
  let n = 0;
  try { n = Number(await contar()) || 0; } catch { n = 0; }
  if (n <= 0) { cerrar(); return 'cerrada'; }
  preguntar(n);
  return 'pregunta';
}

/** Los textos de la confirmación, en un solo sitio para la pantalla y su prueba. */
export function textosDeSalida(n) {
  const cuantos = n === 1 ? '1 pendiente de enviar guardado' : `${n} pendientes de enviar guardados`;
  return {
    titulo: `Tienes ${cuantos} en este teléfono`,
    descripcion: n === 1
      ? 'Si cierras sesión se queda guardado y se enviará cuando vuelvas a entrar con esta cuenta. Las listas copiadas para trabajar sin señal sí se borran.'
      : 'Si cierras sesión se quedan guardados y se enviarán cuando vuelvas a entrar con esta cuenta. Las listas copiadas para trabajar sin señal sí se borran.',
    cerrar: 'Cerrar sesión',
    quedarme: 'Quedarme',
  };
}
